import CelMoney from "@/components/functionals/CelMoney";
import RenderCheckLabel from "@/components/functionals/RenderCheckLabel";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";

export default [
  {
    prop: "rnc",
    name: "NO",
    label: "RNC del Cliente",
    width: 150,
    sortable: true
  },
  {
    prop: "clientname",
    label: "Nombre Cliente",
    minWidth: 100,
    sortable: true
  },
  {
    prop: "status",
    label: "Estado Empresa",
    sortable: true,
    formatter: RenderCheckLabel
  },
  {
    prop: "razon",
    name: "Razon",
    label: "Motivo de Corte",
    minWidth: 100,
    sortable: true
  },
  {
    prop: "clientecode",
    label: "Codigo Navition",
    sortable: true
  },
  {
    prop: "trackers_count",
    label: "Cantidad de Terminales",
    sortable: true
  },
  {
    prop: "Invoices",
    label: "Cantidad de factura",
    sortable: true
  },
  {
    prop: "saldo",
    label: "Saldo Pendiente",
    sortable: true,
    formatter: CelMoney
  },

  {
    prop: "daysInactive",
    label: "Disas desactivados",
    minWidth: 100,
    sortable: true
  },
  {
    prop: "cutAt",
    label: "Fecha de corte",
    minWidth: 100,
    sortable: true,
    attrs: {
      onlyDate: true
    },
    formatter: DatetimeFormatter
  }
];
